// extracted by mini-css-extract-plugin
module.exports = {"tabButtons":"TabButtons_tabButtons__3qVi0","tabBtn":"TabButtons_tabBtn__2TZlL"};